import styled from "styled-components/macro";
import { ReactComponent as UploadDoc } from "assets/svgs/upload-doc.svg";
import { ReactComponent as SuccessCheck } from "assets/svgs/success-check.svg";
import { Progress } from "@gcs/design-system/react";

export const FileInputContainer = styled.div(
  ({ theme, dragging, success, error }) => {
    let border = `1px dashed ${theme.color.line.medium}`;
    if (dragging) {
      border = `4px dashed ${theme.color.line.medium}`;
    }
    if (success) {
      border = "1px solid #002364";
    }
    if (error) {
      border = `1px solid ${theme.color.feedback.error}`;
    }
    return {
      display: "flex",
      flexDirection: "column",
      padding: "16px",
      alignItems: "left",
      border: border,
      background: dragging ? "rgba(255,255,255,.8)" : "default",
      boxSizing: "border-box",
      borderRadius: "8px",
      maxWidth: "350px",
      opacity: dragging ? "0.2" : 1,
      margin: "32px 0 0 0",
      [theme.breakpoint.md()]: {
        padding: "20px",
        margin: "16px 0 40px",
        Width: "500px",
      },
    };
  }
);

export const TitleContainer = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
}));

export const FileInputTitle = styled.h4(({ theme, error }) => ({
  color: error ? theme.color.feedback.error : theme.color.neutral["02"],
  fontSize: "18px",
  fontWeight: "bold",
  fontStyle: "normal",
  lineHeight: "160%",
  textAlign: "left",
  marginBottom: "10px",
  [theme.breakpoint.md()]: {
    fontSize: "20px",
  },
}));

export const FileInputSubTitleLight = styled.p(({ theme }) => ({
  color: theme.color.neutral["03"],
  fontSize: "18px",
  fontWeight: "500",
  fontStyle: "normal",
  lineHeight: "160%",
  textAlign: "left",
  margin: 0,
  [theme.breakpoint.md()]: {
    fontSize: "20px",
  },
}));

export const FileInputTitleLink = styled.a(({ theme, $shouldBeInFront }) => ({
  fontSize: "20px",
  color: theme.color.brandPrimary.light,
  fontWeight: "bold",
  marginTop: "0",
  fontStyle: "normal",
  lineHeight: "160%",
  textAlign: "left",
  overflowWrap: "anywhere",
  cursor: "pointer",
  display: "flex",
  gap: "10px",
  alignItems: "baseline",
  textDecoration: "underline",
  marginBottom: "12px",
  zIndex: $shouldBeInFront ? 50 : -1,
  [theme.breakpoint.md()]: {
    margin: "0",
    marginBottom: "20px",
  },
}));

export const FileInputSubTitle = styled.p(({ theme }) => ({
  fontSize: "16px",
  color: "#7F9398",
  fontWeight: "bold",
  lineHeight: "150%",
  margin: "0 0 12px 0px",
  fontStyle: "normal",
  textAlign: "left",
  zIndex: -1,
  [theme.breakpoint.md()]: {
    margin: "0 0 12px 0px",
  },
}));

export const FileInputDetails = styled.p(({ theme }) => ({
  fontSize: "14px",
  color: theme.color.neutral["03"],
  margin: "12px",
  fontStyle: "normal",
  lineHeight: "150%",
  fontWeight: "500",
  textAlign: "left",
  zIndex: -1,
  [theme.breakpoint.md()]: {
    margin: "12px 0",
    marginBottom: "0",
  },
}));

export const ContainerRow = styled.div(({ theme, $shouldBeInFront }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  zIndex: $shouldBeInFront ? 50 : -1,
}));

export const ContainerFlex = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  zIndex: -1,
  alignItems: "left",
  [theme.breakpoint.md()]: {
    flexDirection: "column",
  },
}));

export const ContainerColumn = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "left",
}));

export const ButtonText = styled.p(({ theme, error }) => ({
  fontSize: "16px",
  color: error ? theme.color.feedback.error : theme.color.brandPrimary.light,
  marginTop: "5px",
  fontStyle: "normal",
  lineHeight: "19px",
  fontWeight: "500",
  textAlign: "left",
  paddingLeft: "5px",
}));

export const Bar = styled.p(({ theme }) => ({
  borderLeft: `1px solid ${theme.color.line.medium}`,
  height: "28px",
  margin: "0 5px",
  [theme.breakpoint.md()]: {
    margin: "0 16px",
  },
}));

export const FlexRow = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  margin: 0,
}));

export const ErrorMessage = styled.h6(({ theme }) => ({
  textAlign: "inherit",
  display: "flex",
  alignItems: "center",
  svg: {
    margin: "0 5px",
    width: "1rem",
  },
  color: theme.color.feedback.error,
  marginTop: 0,
  marginBottom: 0,
  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "150%",
}));

export const StyledUploadDoc = styled(UploadDoc)(
  ({ theme, $shouldBeInFront }) => ({
    display: "none",
    cursor: "pointer",
    [theme.breakpoint.md()]: {
      display: "block",
      zIndex: $shouldBeInFront ? 50 : -1,
    },
  })
);

export const StyledSuccessCircle = styled(SuccessCheck)(({ theme }) => ({
  zIndex: -1,
  width: "25px",
  [theme.breakpoint.md()]: {
    width: "40px",
  },
}));

export const StyledProgressBar = styled(Progress)(({ theme }) => ({
  margin: "24px 0",
  width: "80%",
  [theme.breakpoint.md()]: {
    margin: "36px 0 12px",
  },
}));

export const ModifyButtonsContainer = styled.div(
  ({ theme, $shouldBeInFront }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    zIndex: $shouldBeInFront ? 50 : -1,
    justifyContent: "space-between",
    marginTop: "16px",
    [theme.breakpoint.md()]: {
      marginTop: "24px",
    },
  })
);

export const StyledMobileButtons = styled.div(
  ({ theme, $shouldBeInFront }) => ({
    display: "flex",
    zIndex: $shouldBeInFront ? 50 : -1,
    margin: "0",
    [theme.breakpoint.md()]: {
      display: "none",
      margin: "0 5px",
    },
  })
);

export const StyledLink = styled.a(({ theme }) => ({
  display: "none",
  cursor: "pointer",
  color: "#d70064",
  fontWeight: "500",
  fontSize: "16px",
  lineHeight: "150%",
  textDecoration: "underline",
  marginLeft: "15px",
  ":hover": {
    fontWeight: "bold",
  },
  [theme.breakpoint.md()]: {
    display: "block",
  },
}));
